import DocumentActionTypes from "../../actions/document/types";

export default (documentReferences = null, action) => {
  switch (action.type) {
    case DocumentActionTypes.FETCH_DOCUMENT_REFERENCES:
      return action.payload;
    default:
      return documentReferences;
  }
};
